export default class DeleteAttachmentRecordError extends Error {

}
